import { useUser } from "./use-user";


export const useCredits = () => {
  const { user, newCredits } = useUser();
  const credits = newCredits > 0 ? newCredits : user?.credit;
  return credits;
};
